import { ObjectTools } from '../../../tools/object-tools';
import { SolIcon } from '@sol/icons';
import { SolShortcut } from '../../../services/shortcut.service';
import { SolButtonType } from '../../../models/core/sol-button';

export class SolPopoverMenuItemState {
  private constructor(
    public readonly disabled: boolean,
    public readonly type: SolButtonType,
    public readonly icon: SolIcon | undefined,
    public readonly text: string,
    public readonly params: Record<string, any>,
    public readonly hint: string,
    public readonly shortcut: SolShortcut | undefined,
    public readonly selected: boolean,
    public readonly translatable: boolean,
    public readonly autoFocus: boolean,
    public readonly hostClass: string,
  ) {}

  public static of(): SolPopoverMenuItemState {
    return new SolPopoverMenuItemState(
      false,
      SolButtonType.secondary,
      undefined,
      '',
      {},
      '',
      undefined,
      false,
      true,
      true,
      'sol-popover-menu-item',
    );
  }

  public withParams(params: Record<string, any>): SolPopoverMenuItemState {
    if (ObjectTools.equals(this.params, params)) return this;
    return this.copy({ params });
  }

  public withAutoFocus(autoFocus: boolean): SolPopoverMenuItemState {
    if (this.autoFocus === autoFocus) return this;
    return this.copy({ autoFocus });
  }

  public withDisabled(disabled: boolean): SolPopoverMenuItemState {
    return this.copy({ disabled }).recalculateHostClass();
  }

  public withType(type: SolButtonType): SolPopoverMenuItemState {
    return this.copy({ type }).recalculateHostClass();
  }

  public withIcon(icon: SolIcon | undefined): SolPopoverMenuItemState {
    return this.copy({ icon });
  }

  public withText(text: string): SolPopoverMenuItemState {
    return this.copy({ text });
  }

  public withHint(hint: string): SolPopoverMenuItemState {
    return this.copy({ hint });
  }

  public withShortcut(shortcut: SolShortcut | undefined): SolPopoverMenuItemState {
    return this.copy({ shortcut });
  }

  public withSelected(selected: boolean): SolPopoverMenuItemState {
    return this.copy({ selected }).recalculateHostClass();
  }

  public withTranslatable(translatable: boolean): SolPopoverMenuItemState {
    return this.copy({ translatable });
  }

  private recalculateHostClass(): SolPopoverMenuItemState {
    let hostClass = 'sol-popover-menu-item';
    if (this.disabled) {
      hostClass += '-disabled';
    } else if (this.selected) {
      hostClass += '-selected';
    }

    if (this.type === SolButtonType.danger) {
      hostClass += ' sol-popover-menu-item-danger';
    }
    return this.copy({ hostClass });
  }

  private copy(props: Partial<SolPopoverMenuItemState>): SolPopoverMenuItemState {
    return ObjectTools.copy<SolPopoverMenuItemState>(this, props);
  }
}
